var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-property",class:{ 'is-disabled': _vm.disabled }},[_c('h4',{class:{ 'is-disabled': _vm.disabled }},[_vm._v(_vm._s(_vm.item.label)+" "),(_vm.item.quickinfo)?_c('Quickinfo',{attrs:{"item":_vm.item}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }